export default __webpack_public_path__ + "static/icon2-1347b6760783d379a1cd921ec997eb99.png";